module.exports = __webpack_public_path__ + "static/media/wf.ed7cd0ae.jpeg";